export default function ({
  PID,
  CountryCode,
  OperatorID,
  BrandUnikID,
  VerifyURL,
  AccountNumber,
  ServiceRef,
  TargetType,
  ActionType,
  Category,
  ShortName,
  OperatorName,
  APIKey,
  AppID,
  LoginName,
  ID,
}: {
  PID: string;
  CountryCode?: string;
  OperatorID?: string;
  BrandUnikID?: string;
  VerifyURL?: string;
  AccountNumber?: any;
  ServiceRef?: string;
  TargetType?: string;
  ActionType?: string;
  Category?: string;
  ShortName?: string;
  OperatorName?: string;
  APIKey?: string;
  AppID?: string;
  LoginName?: string;
  ID?: string;
}) {
  return {
    PID,
    CountryCode,
    OperatorID,
    BrandUnikID,
    VerifyURL,
    AccountNumber: AccountNumber,
    ServiceRef,
    TargetType,
    ActionType,
    Category,
    ShortName,
    OperatorName,
    APIKey,
    AppID,
    LoginName,
    ID,
  };
}
